import { FontIcon, Icon } from "@fluentui/react";
import { getFileTypeIconProps } from "@fluentui/react-file-type-icons";
import { notification } from "antd";
import React, { memo, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";

function FileUploadNotification(props: any) {
  const fileUploadCompleted = useSelector((state: RootState) => state.engageTranslationState.engageTranslateMainState.fileUploadCompleted);
  //Notification hook
  const [api, contextHolder] = notification.useNotification();
  type NotificationType = "success" | "info" | "warning" | "error";
  const openNotificationWithIcon = (type: NotificationType) => {
    api[type]({
      message: <b className="px-3">{fileUploadCompleted.status === "success" ? "File Upload Successful" : "File Upload Failed"}</b>,
      description: (
        <div className="notification px-3">
          {type === "success" ? (
            <div>
              The document <b>{fileUploadCompleted.fileName}</b> has been uploaded successfully
            </div>
          ) : (
            <span>
              The document <b>{fileUploadCompleted.fileName}</b> has been uploaded unsuccessfully
            </span>
          )}
        </div>
      ),
      icon:
        type === "success" ? (
          <Icon
            {...getFileTypeIconProps({
              extension: fileUploadCompleted.fileExtension,
              size: 40,
              imageFileType: "svg",
            })}
          />
        ) : (
          <FontIcon
            iconName="AlertSolid"
            className="mt-4"
          />
        ),
    });
  };

  useEffect(() => {
    if (fileUploadCompleted.status === "success") {
      openNotificationWithIcon("success");
    } else if (fileUploadCompleted.status === "exception") {
      openNotificationWithIcon("error");
    }
  }, [fileUploadCompleted]);

  //   useEffect(() => {
  //     if (fileUploadState.status === "success") {
  //       openNotificationWithIcon("success");
  //     } else if (fileUploadState.status === "exception") {
  //       openNotificationWithIcon("error");
  //     }
  //   }, [fileUploadState.status]);
  return <div>{contextHolder}</div>;
}

export default FileUploadNotification;
